import { useState } from "react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useStore } from "../lib/storeContext";

export function AppShell({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth();
  const { reload, loading } = useStore();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-full bg-paper">
      <header className="sticky top-0 z-30 border-b border-black/5 bg-paper/85 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/logo.png" alt="" className="h-9 w-9 rounded-xl object-contain" />
            <div className="leading-tight">
              <div className="text-base font-bold text-ink">Cedar Post</div>
              <div className="text-[11px] uppercase tracking-wide text-muted">Home projects</div>
            </div>
          </Link>

          <div className="flex items-center gap-2">
            <Link to="/objects" className="btn-ghost text-sm" title="Object capture — 3D digital twins">
              ⬢ Objects
            </Link>
            <Link to="/models" className="btn-ghost text-sm" title="Inspect photoreal models">
              ✦ Models
            </Link>
            <button
              className="btn-ghost text-sm"
              onClick={reload}
              disabled={loading}
              title="Refresh from cloud"
            >
              {loading ? "Syncing…" : "Refresh"}
            </button>
            <div className="relative">
              <button
                className="flex h-9 w-9 items-center justify-center rounded-full bg-warm font-semibold text-white"
                onClick={() => setMenuOpen((o) => !o)}
                title={user?.email ?? "Account"}
              >
                {(user?.name ?? user?.email ?? "?").slice(0, 1).toUpperCase()}
              </button>
              {menuOpen && (
                <div
                  className="absolute right-0 mt-2 w-56 overflow-hidden rounded-card bg-card shadow-lift"
                  onMouseLeave={() => setMenuOpen(false)}
                >
                  <div className="border-b border-black/5 px-4 py-3">
                    <div className="truncate text-sm font-semibold text-ink">{user?.name ?? "Signed in"}</div>
                    <div className="truncate text-xs text-muted">{user?.email}</div>
                  </div>
                  <button
                    className="block w-full px-4 py-3 text-left text-sm text-ink hover:bg-cream"
                    onClick={signOut}
                  >
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-5 py-6">{children}</main>
    </div>
  );
}
